import { useTranslation } from "react-i18next";
import { Box, Flex, Button } from "@chakra-ui/react";
import { useParentStation } from "src/modules/parent-station/ParentStation/Context";
import NoiseSensitivitySelector from "src/modules/station/components/NoiseSensitivitySelector";
import Modal from "src/components/Modal";

export default function ParentStationNoiseSensitivty({ isOpen, onClose }) {
  const { t } = useTranslation();
  const parentStation = useParentStation();
  const { primaryStation, handleMicSensitivityChange } = parentStation;
  const { remoteSettings } = primaryStation;
  return (
    <Modal isOpen={isOpen}>
      <Box width="280px">
        <Box pt="24px" px="24px">
          <NoiseSensitivitySelector
            selected={remoteSettings.micSensitivity}
            onChange={handleMicSensitivityChange}
          />
        </Box>
        <Flex mt="22px" pr="8px" pb="8px" justifyContent="flex-end">
          <Button
            variant="flatPrimary"
            onClick={onClose}
            minWidth="80px"
            mr="8px"
          >
            {t("buttons.cancel")}
          </Button>
          <Button variant="flatPrimary" onClick={onClose} minWidth="80px">
            {t("buttons.ok")}
          </Button>
        </Flex>
      </Box>
    </Modal>
  );
}
